import React from "react";
import { Row, Col, Divider, Select, Form, Input, Typography } from "antd";
import map from "lodash/map";
import get from "lodash/get";
import last from "lodash/last";
import assign from "lodash/assign";
import DeviceCascaderSelector from "../../../../common/deviceCascaderSelector";

const { Text } = Typography;

const GraphInfoForm = ({
  templateConfig,
  onSelectDevice,
  onSelectModule,
  form,
  entityTree,
  localState,
}) => {
  let i = -1;
  return (
    <>
      {map(templateConfig, (config, key) => {
        return (
          <>
            <Divider orientation="left">
              Graph : {get(config, "graph_label")}
            </Divider>
            {map(get(config, "fields"), (field) => {
              const currentIndex = i + 1;
              i++;

              const isRequired = get(field, "required");

              return (
                <Row gutter={10} className=" w-full">
                  <Col xl={4} xs={24} className="flex flex-row items-center">
                    <Text keyboard level={5}>
                      {get(field, "label")} :{" "}
                    </Text>
                  </Col>
                  <Col xl={8} xs={24}>
                    <DeviceCascaderSelector
                      data={entityTree}
                      required={isRequired}
                      name={["graph", currentIndex, "device_id"]}
                      onChange={(value) => {
                        const deviceArr = last(value).split("@");
                        if (deviceArr[0] === "DEVICE") {
                          onSelectDevice(deviceArr[1], currentIndex);
                          const graph = get(
                            { ...form.getFieldsValue() },
                            "graph"
                          );
                          assign(graph[currentIndex], {
                            module_id: undefined,
                            event_id: undefined,
                          });
                          form.setFieldsValue({ graph });
                        }
                      }}
                    />
                  </Col>
                  <Col xl={6} xs={24}>
                    <Form.Item
                      name={["graph", currentIndex, "module_id"]}
                      label="Module"
                      rules={
                        isRequired
                          ? [
                              {
                                required: true,
                                message: "Please select module!",
                              },
                            ]
                          : []
                      }
                    >
                      <Select
                        size="small"
                        placeholder="Select Module"
                        onChange={(value) => {
                          onSelectModule(value, currentIndex);
                        }}
                      >
                        {map(
                          get(localState, `${currentIndex}.device.modules`),
                          (module) => (
                            <Option value={get(module, "id")}>
                              {get(module, "name")}
                            </Option>
                          )
                        )}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xl={5} xs={24}>
                    <Form.Item
                      name={["graph", currentIndex, "event_id"]}
                      label="Event Field"
                      rules={
                        isRequired
                          ? [
                              {
                                required: true,
                                message: "Please select event field!",
                              },
                            ]
                          : []
                      }
                    >
                      <Select
                        size="small"
                        placeholder="Select Event field"
                        onChange={(value) => {}}
                      >
                        {map(
                          get(
                            localState,
                            `${currentIndex}.module.eventFieldVOS`,
                            []
                          ),
                          (field) => (
                            <Option value={get(field, "id")}>
                              {get(field, "displayName")} (
                              {get(field, "fieldName")})
                            </Option>
                          )
                        )}
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col xl={1} xs={24}>
                    <Form.Item
                      name={["graph", currentIndex, "setting_id"]}
                      label=""
                    >
                      <Input size="small" type="hidden" />
                    </Form.Item>
                  </Col>
                </Row>
              );
            })}
          </>
        );
      })}
    </>
  );
};
export default GraphInfoForm;
